import { render, staticRenderFns } from "./InscripcionPagada.vue?vue&type=template&id=4948c49f&"
import script from "./InscripcionPagada.vue?vue&type=script&lang=js&"
export * from "./InscripcionPagada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports